import { iterate } from "../iterate";

export class Thresholds{
	public constructor(
		public positions:number[]
	){
	}

	public indexOf(v:number){
		for(let i=0;i<this.positions.length;++i){
			if(v<this.positions[i]){
				return i-1;
			}
		}
		return this.positions.length-1;
	}


	private dataPercentagesFromLine(data:[number,number][]){
		let out=this.positions.slice(0,this.positions.length-1).map(()=>0);
		const _data:[number,number][]=[[data[0][0],this.indexOf(data[0][1])]];
		for(const [a,b] of data.pairs()){
			for(const [i,p] of this.positions.entries()){
				if(a[1]<=p && p<b[1]){
					const f=(p-a[1])/(b[1]-a[1]);
					const x=a[0]+(b[0]-a[0])*f;
					_data.push([x,i]);
				}else if(a[1]>p && p>=b[1]){
					const f=(p-a[1])/(b[1]-a[1]);
					const x=a[0]+(b[0]-a[0])*f;
					_data.push([x,i-1]);
				}
			}
		}
		_data.push([data.at(-1)![0],this.indexOf(data.at(-1)![1])]);
		data=_data;
		for(const [a,b] of data.pairs()){
			const w=b[0]-a[0];
			if(out[a[1]]!==undefined)
				out[a[1]]+=w;
		}
		const totalWeight=out.reduce((a,b)=>a+b,0);
		if(totalWeight>0)
			out=out.map(v=>v/totalWeight);
		return out;
	}

	private dataPercentagesFromWeighted(data:{value:number;weight:number}[]){
		let out=this.positions.slice(0,this.positions.length-1).map(()=>0);
		for(const {value,weight} of data){
			const i=this.indexOf(value);
			if(out[i]!==undefined)
				out[i]+=weight;
		}
		const totalWeight=out.reduce((a,b)=>a+b,0);
		if(totalWeight>0)
			out=out.map(v=>v/totalWeight);
		return out;
	}

	public dataPercentages(data:([number,number][])|({value:number;weight:number}[])){
		if(data.length===0)
			return this.positions.slice(0,this.positions.length-1).map(()=>0);
		if(Array.isArray(data[0])){
			return this.dataPercentagesFromLine(<[number,number][]>data);
		}
		return this.dataPercentagesFromWeighted(<{value:number;weight:number}[]>data);

	}
}